import { Dialog as BaseUiDialog } from '@base-ui-components/react/dialog';
import type React from 'react';
import { twMerge } from 'tailwind-merge';

import type { CommonProps } from '#/ui/utils/types';

export interface DialogContentProps extends CommonProps {
  children?: React.ReactNode;
  dividers?: boolean;
}

function DialogContent({ children, className, dividers = false }: DialogContentProps) {
  return (
    <BaseUiDialog.Description
      className={twMerge('gooey-dialog-content', dividers && 'border-y py-4', className)}
    >
      {children}
    </BaseUiDialog.Description>
  );
}
DialogContent.displayName = 'GooeyDialogContent';

export default DialogContent;
